import { useState, useEffect } from 'react';
// components
import Dialog from '../../components/dialog';
import { PasswordField, ButtonField, Label, CodeFields, Message as FormMessage } from '../../components/hook-form';
// @form
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// @moment
import moment from 'moment-timezone';
// utils
import { REGEXP_EMAIL, REGEXP_PASSWORD } from '../../utils/regexp';
// styles
import { Tabs, Message, ButtonWrapper, PrimaryButton, TertiaryButton } from '../../styles';
// apis
import { verifyEmail, updateEmail, deleteEmail, changePassword } from '../../apis';

// ----------------------------------------------------------------------

interface Props {
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
};

interface PasswordValues {
  current?: string;
  new?: string;
  confirm?: string;
};

const passwordSchema = yup.object().shape({
  current: yup.string()
    .required(),
  new: yup.string()
    .required()
    .matches(REGEXP_PASSWORD, '비밀번호 형식을 확인해 주세요.'),
  confirm: yup.string()
    .required()
    .oneOf([yup.ref('new'), null], '비밀번호가 일치하지 않습니다.')
});

// ----------------------------------------------------------------------

export default function SecurityDialog({ setVisible }: Props) {
  const handleClose = () => setVisible(false);

  const {
    control,
    watch,
    trigger,
    handleSubmit
  } = useForm({
    mode: 'onChange',
    resolver: yupResolver(passwordSchema),
    defaultValues: {
      current: '',
      new: '',
      confirm: ''
    }
  });

  const [ success, setSuccess ] = useState(null);

  const [ submit, setSumbit ] = useState(false);

  useEffect(() => {
    if ( submit ) trigger('confirm');
  }, [watch('new')]);
  
  const [ message, setMessage ] = useState(null);

  const onError = async () => {
    if ( !submit ) setSumbit(true);
  };

  const onSubmit = async (data: PasswordValues) => {
    if ( !submit ) setSumbit(true);
    await changePassword(data.current, data.new)
      .then(() => setSuccess(true))
      .catch(() => setMessage('비밀번호를 변경할 수 없습니다\n나중에 다시 시도해 주세요.'));
  };

  return (
    <Dialog
      title='보안 설정'
      handleClose={handleClose}
    >
      { !success ? (
        <form onSubmit={ handleSubmit(onSubmit, onError) }>
          <PasswordField
            name='current'
            label='현재 비밀번호'
            control={control}
          />

          <PasswordField
            name='new'
            label='신규 비밀번호'
            control={control}
          />

          <PasswordField
            name='confirm'
            label='비밀번호 확인'
            control={control}
          />

          <Message $visible={message ? true : false}>{ message }</Message>

          <ButtonWrapper>
            <PrimaryButton type='submit'>
              수정
            </PrimaryButton>
            <TertiaryButton type='button' onClick={() => handleClose()} >
              취소
            </TertiaryButton>
          </ButtonWrapper>
        </form>
      ) : (
        <>
          <p style={{'marginBottom': '30px'}}>비밀번호 변경이 완료되었습니다.</p>

          <PrimaryButton type='button' onClick={() => handleClose()}>확인</PrimaryButton>
        </>
      )}
    </Dialog>
  );
}